import caminantesC1 from "../../maps/routes/caminantes-c1.json";
import { ECUADOR_MAP_PACKS, type EcuadorMapPack } from "../../shared/ecuador-map-packs";
import type { RouteGeoJson } from "./route-workflow";

export type ActivityKind = "senderismo" | "escalada" | "rapel";

export type RouteItem = {
  id: string;
  name: string;
  area: string;
  kind: ActivityKind;
  distance: string;
  time: string;
  ascent: string;
  difficulty: string;
  points: string;
  tags: string[];
  status: "Publicada" | "En revisión";
  source?: {
    label: string;
    url: string;
    license: string;
  };
  geojson?: RouteGeoJson;
};

export type OfflinePack = EcuadorMapPack;

export const routes: RouteItem[] = [
  {
    id: "caminantes-c1",
    name: "CaminANTES · Zhinglla–Cachaulo",
    area: "Azuay · Cuenca",
    kind: "senderismo",
    distance: "12,2 km",
    time: "3 h 30 min estimado",
    ascent: "+597 m estimado",
    difficulty: "Moderada · validar",
    points: "22,88 49,75 78,65 108,58 138,49 169,42 199,51 229,37 261,32 294,26 346,34",
    tags: ["Senderismo", "Trazado abierto", "OSM C1"],
    status: "En revisión",
    source: {
      label: "OpenStreetMap · relación 10298053",
      url: "https://www.openstreetmap.org/relation/10298053",
      license: "ODbL 1.0",
    },
    geojson: caminantesC1 as unknown as RouteItem["geojson"],
  },
  {
    id: "cajas-luspa",
    name: "Tres Cruces · Luspa",
    area: "Parque Nacional Cajas",
    kind: "senderismo",
    distance: "12,8 km",
    time: "4 h 40 min",
    ascent: "+690 m",
    difficulty: "Moderada",
    points: "22,94 42,78 67,72 91,48 117,56 142,31 171,40 199,20 226,35 254,25 285,42 316,26 346,34",
    tags: ["Senderismo", "Páramo", "Lagunas"],
    status: "Publicada",
  },
  {
    id: "cotopaxi-refugio",
    name: "Entorno del Cotopaxi",
    area: "Parque Nacional Cotopaxi",
    kind: "senderismo",
    distance: "Ruta demostrativa",
    time: "Por validar",
    ascent: "Por validar",
    difficulty: "Alta montaña",
    points: "22,91 48,79 77,83 103,61 134,67 162,44 191,53 221,31 250,43 282,22 315,36 346,20",
    tags: ["Alta montaña", "Volcán", "Offline"],
    status: "En revisión",
  },
  {
    id: "altar-azul",
    name: "Laguna Azul · El Altar",
    area: "Parque Nacional Sangay",
    kind: "senderismo",
    distance: "24,2 km",
    time: "8 h 15 min",
    ascent: "+1.120 m",
    difficulty: "Difícil",
    points: "22,88 45,84 74,69 102,73 129,49 156,55 182,32 210,47 239,26 269,39 301,18 346,28",
    tags: ["Trekking", "Alta montaña", "Laguna"],
    status: "Publicada",
  },
  {
    id: "cojitambo",
    name: "Vuelta a Cojitambo",
    area: "Cañar",
    kind: "senderismo",
    distance: "8,6 km",
    time: "2 h 20 min",
    ascent: "+410 m",
    difficulty: "Fácil",
    points: "22,76 49,69 78,76 108,58 138,64 169,47 199,56 229,39 261,47 294,32 346,40",
    tags: ["Senderismo", "Mirador", "Arqueología"],
    status: "Publicada",
  },
];

export const climbingPlaces = [
  {
    id: "cojitambo-roca",
    name: "Cojitambo · sector de roca",
    area: "Cañar",
    kind: "Escalada en roca",
    grade: "Información por verificar",
    access: "Aproximación y anclajes sujetos a revisión",
    marker: { left: "64%", top: "34%" },
  },
  {
    id: "sayousi-roca",
    name: "Sayausí · punto comunitario",
    area: "Azuay",
    kind: "Escalada y rápel",
    grade: "Información por verificar",
    access: "Publicación pendiente de validación administrativa",
    marker: { left: "33%", top: "58%" },
  },
];

export const offlinePacks: OfflinePack[] = ECUADOR_MAP_PACKS;

export const communityActivity = [
  { initials: "AM", name: "Ana M.", action: "registró una actividad en", route: "Parque Nacional Cajas", stat: "Datos visibles con su autorización" },
  { initials: "JR", name: "José R.", action: "compartió una recomendación en", route: "Cojitambo", stat: "Contenido comunitario" },
  { initials: "CV", name: "Carla V.", action: "añadió fotografías a", route: "El Altar", stat: "Imágenes convertidas a WebP" },
];
